import { render, staticRenderFns } from "./addCommoditymasterdata.vue?vue&type=template&id=31b51100&scoped=true&"
import script from "./addCommoditymasterdata.vue?vue&type=script&lang=js&"
export * from "./addCommoditymasterdata.vue?vue&type=script&lang=js&"
import style0 from "./addCommoditymasterdata.vue?vue&type=style&index=0&id=31b51100&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b51100",
  null
  
)

export default component.exports